'use client';

import useApexDomain from '@alltrails/context/hooks/useApexDomain';
import { useEffect } from 'react';
import { SessionAttribution } from '../types/sessionAttribution';
import useSessionStorage from './useSessionStorage';

/* 
  Store initial utm parameters and referring domain in sessionStorage.
  This is used to provide attribution data to AppsFlyer deeplinks.
*/
const useCaptureSessionAttribution = (pageReferer?: string | null) => {
  const apexDomain = useApexDomain();
  const { getValue, setValue } = useSessionStorage('sessionAttribution');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams: (keyof SessionAttribution)[] = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_content', 'utm_term'];

    if (!getValue()) {
      const sessionAttribution: SessionAttribution = {};
      const referer = pageReferer || document.referrer;

      const hostName = referer ? new URL(referer).hostname : '';
      const referrerDomain = !hostName.includes(apexDomain) ? hostName : undefined;

      if (referrerDomain) {
        sessionAttribution['referring_domain'] = referrerDomain;
      }

      utmParams.forEach(param => {
        const value = urlParams.get(param);
        if (value) {
          sessionAttribution[param] = value;
        }
      });

      setValue(sessionAttribution);
    }
  }, [apexDomain, getValue, pageReferer, setValue]);
};

export default useCaptureSessionAttribution;
